@if (buildingEquipment(); as dto) {
  <div class="qr-page">

    <div class="qr-back-header">
      <button nbButton ghost status="basic" size="small" (click)="goBack()">
        <nb-icon pack="eva" icon="arrow-back-outline"></nb-icon>
      </button>
      <div class="qr-back-info">
        <span class="qr-back-title">{{ dto.equipment.name }}</span>
      </div>
    </div>

    @if (canCreateRepairTask()) {
      <button nbButton fullWidth status="primary" data-cy="qr-create-repair-task"
              [disabled]="creatingRepairTask()" (click)="createRepairTask()">
        <nb-icon icon="plus-outline" pack="eva"></nb-icon>
        Reparaturauftrag erstellen
      </button>
    }

    <div class="info-card">
      @if (dto.equipment.description) {
        <div class="info-row">
          <span class="info-label">Beschreibung</span>
          <span class="info-value">{{ dto.equipment.description }}</span>
        </div>
      }
      <div class="info-row">
        <span class="info-label">Anzahl</span>
        <span class="info-value">{{ dto.quantity }}</span>
      </div>
      @if ($any(dto.equipment.facilityElements)?.length) {
        <div class="info-row">
          <span class="info-label">Zugewiesen an</span>
          @for (facilityElement of dto.equipment.facilityElements; track $index) {
            <span class="info-value">{{ facilityElement | facilityElementTranslation }}</span>
          }
        </div>
      }
      <div class="info-row">
        <span class="info-label">Erstellt von</span>
        <span class="info-value">{{ dto.creatorTenant }}</span>
      </div>
    </div>

    @if (timerOptions()?.canCreate || timers().length > 0) {
      <div class="timer-section" data-cy="qr-timer-section">
        <span class="attachment-label">Wartungstimer</span>
        @if (timers().length > 0) {
          <div class="timer-list" data-cy="qr-timer-list">
            @for (timer of timers(); track timer.id) {
              <div class="info-card timer-card" data-cy="qr-timer-item">
                <div class="timer-card-header">
                  <span class="info-value">{{ timer.type | maintenanceTimerType }}</span>
                  <span class="timer-days"
                        [class.timer-days--overdue]="daysLeft(timer) < 0">
                    {{ daysLeft(timer) }} {{ daysLeft(timer) | pluralize: 'Tag' : 'Tage' }}
                  </span>
                </div>
                <div class="timer-card-meta">
                  <span>Nächster Termin {{ timer.nextDate | date: 'dd.MM.yyyy' }}</span>
                  <span>Intervall {{ timer.durationDays }} {{ timer.durationDays | pluralize: 'Tag' : 'Tage' }}</span>
                  <span>Erinnerung {{ timer.reminderDate | date: 'dd.MM.yyyy' }}</span>
                </div>
              </div>
            }
          </div>
        }
        @if (timerOptions()?.canCreate) {
          @if (!timerFormOpen()) {
            <button nbButton outline status="primary" fullWidth
                    data-cy="qr-timer-open-form"
                    (click)="openTimerForm()">
              <nb-icon icon="plus-outline" pack="eva"></nb-icon>
              Wartungstimer anlegen
            </button>
          } @else {
            <div class="info-card timer-form" data-cy="qr-timer-form">
              <div class="info-row">
                <label class="info-label" for="qr-timer-type">Art</label>
                <nb-select id="qr-timer-type" fullWidth
                           data-cy="qr-timer-type"
                           [selected]="selectedTimerType()"
                           (selectedChange)="selectTimerType($event)">
                  @for (type of timerTypes; track type) {
                    <nb-option [value]="type">{{ type | maintenanceTimerType }}</nb-option>
                  }
                </nb-select>
              </div>
              <div class="info-row">
                <span class="info-label">Startdatum</span>
                <span class="info-value" data-cy="qr-timer-start-date">{{ today | date: 'dd.MM.yyyy' }}</span>
              </div>
              @if (selectedConfig(); as config) {
                <div class="info-row">
                  <span class="info-label">Intervall</span>
                  <span class="info-value" data-cy="qr-timer-duration">{{ config.durationDays }} Tage</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Nächster Termin</span>
                  <span class="info-value">{{ nextDate() | date: 'dd.MM.yyyy' }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Erinnerung</span>
                  <span class="info-value">{{ config.reminderDurationDays }} Tage vorher</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Fristen</span>
                  <span class="info-value">
                    {{ config.earlyToleranceDays }} Tage vor / {{ config.lateToleranceDays }} Tage nach Termin
                  </span>
                </div>
                <div class="info-row">
                  <span class="info-label">Bild beim Abschließen</span>
                  <span class="info-value">{{ config.imagesMandatory ? 'Pflicht' : 'Optional' }}</span>
                </div>
              } @else {
                <div class="info-row">
                  <label class="info-label" for="qr-timer-duration-days">
                    Intervall in Tagen <span class="required">*</span>
                  </label>
                  <input id="qr-timer-duration-days"
                         nbInput
                         fullWidth
                         type="number"
                         inputmode="numeric"
                         min="1"
                         step="1"
                         data-cy="qr-timer-duration-input"
                         [status]="durationDays() !== undefined && !ownValuesValid() ? 'danger' : 'basic'"
                         [value]="durationDays() ?? ''"
                         (input)="durationDays.set(parseDays($any($event.target).value))"/>
                </div>
                <div class="info-row">
                  <label class="info-label" for="qr-timer-reminder-days">
                    Erinnerung in Tagen vorher <span class="required">*</span>
                  </label>
                  <input id="qr-timer-reminder-days"
                         nbInput
                         fullWidth
                         type="number"
                         inputmode="numeric"
                         min="0"
                         step="1"
                         data-cy="qr-timer-reminder-input"
                         [value]="reminderDurationDays() ?? ''"
                         (input)="reminderDurationDays.set(parseDays($any($event.target).value))"/>
                </div>
                @if (!isContractorSession()) {
                  <div class="info-row">
                    <label class="info-label" for="qr-timer-early-days">Frist vor Termin in Tagen</label>
                    <input id="qr-timer-early-days"
                           nbInput
                           fullWidth
                           type="number"
                           inputmode="numeric"
                           min="0"
                           step="1"
                           data-cy="qr-timer-early-input"
                           [value]="earlyToleranceDays() ?? ''"
                           (input)="earlyToleranceDays.set(parseDays($any($event.target).value))"/>
                  </div>
                  <div class="info-row">
                    <label class="info-label" for="qr-timer-late-days">Frist nach Termin in Tagen</label>
                    <input id="qr-timer-late-days"
                           nbInput
                           fullWidth
                           type="number"
                           inputmode="numeric"
                           min="0"
                           step="1"
                           data-cy="qr-timer-late-input"
                           [value]="lateToleranceDays() ?? ''"
                           (input)="lateToleranceDays.set(parseDays($any($event.target).value))"/>
                  </div>
                  <nb-checkbox data-cy="qr-timer-images-mandatory"
                               [checked]="imagesMandatory()"
                               (checkedChange)="imagesMandatory.set($event)">
                    Bild beim Abschließen Pflicht
                  </nb-checkbox>
                }
                @if (nextDate(); as next) {
                  <div class="info-row">
                    <span class="info-label">Nächster Termin</span>
                    <span class="info-value" data-cy="qr-timer-next-date">{{ next | date: 'dd.MM.yyyy' }}</span>
                  </div>
                }
              }
              @if (isContractorSession()) {
                <div class="info-row">
                  <label class="info-label" for="qr-timer-creator">Name <span class="required">*</span></label>
                  <input id="qr-timer-creator"
                         nbInput
                         fullWidth
                         data-cy="qr-timer-creator"
                         placeholder="Ihren Namen eingeben"
                         [attr.maxlength]="maxCreatorNameLength"
                         [value]="creatorName()"
                         (input)="creatorName.set($any($event.target).value)"/>
                </div>
              }
              <div class="timer-actions">
                <button nbButton outline status="basic" (click)="cancelTimerForm()">Abbrechen</button>
                <button nbButton status="primary"
                        data-cy="qr-timer-submit"
                        [disabled]="!canSubmit()"
                        (click)="createTimer()">
                  Anlegen
                </button>
              </div>
              @if (selectedConfig()) {
                <span class="timer-hint">Die Werte stammen aus der Konfiguration des TGA-Bauplans.</span>
              } @else if (selectedDefaultConfig()) {
                <span class="timer-hint" data-cy="qr-timer-prefilled">Vorbelegt aus der Konfiguration des TGA-Bauplans.</span>
              }
            </div>
          }
        }
      </div>
    }

    <div class="attachment-section">
      <span class="attachment-label">Bilder aus Prüfpunktzeilen</span>
      @if (dto.inspectionEntryAttachments && dto.inspectionEntryAttachments.length > 0) {
        <div class="attachment-grid">
          @for (a of dto.inspectionEntryAttachments; track $index) {
            <div class="attachment-item" role="button" tabindex="0" (click)="openPreview(a.presignedUrl)" (keydown.enter)="openPreview(a.presignedUrl)">
              <wr-attachment-preview
                size="small"
                [attachment]="a"
                [isDisabled]="true"
                [selected]="false">
              </wr-attachment-preview>
            </div>
          }
        </div>
      } @else {
        <span class="info-value">Keine Bilder vorhanden</span>
      }
    </div>

    <div class="attachment-section">
      <span class="attachment-label">Bilder & Dokumentenliste der TGA</span>
      @if (dto.attachments && dto.attachments.length > 0) {
        <div class="attachment-grid">
          @for (a of dto.attachments; track $index) {
            <div class="attachment-item" role="button" tabindex="0" (click)="openPreview(a.presignedUrl)" (keydown.enter)="openPreview(a.presignedUrl)">
              <wr-attachment-preview
                size="small"
                [attachment]="a"
                [isDisabled]="true"
                [selected]="false">
              </wr-attachment-preview>
            </div>
          }
        </div>
      } @else {
        <span class="info-value">Keine Bilder vorhanden</span>
      }
    </div>

    <div class="attachment-section" data-cy="qr-public-folders">
      <span class="attachment-label">Dokumente</span>
      @if (dto.tgaDocumentsAccess === 'NO_SCOPE') {
        <wr-banner status="warning"
                   data-cy="qr-tga-documents-no-scope"
                   [icon]="{ icon: 'lock-outline', pack: 'eva' }"
                   message="Keine Freigabe für TGA-Ordner – der Eigentümer kann sie unter Dienstleister → Zugriffe erteilen."></wr-banner>
      } @else {
        @for (folder of publicFolders() ?? []; track folder.id) {
          <div class="folder-card">
            <div class="folder-title">
              <nb-icon icon="folder" pack="eva" [style.color]="folder.color"></nb-icon>
              <span>{{ folder.name }}</span>
            </div>
            @for (attachment of folder.attachments ?? []; track attachment.s3key) {
              <a class="document-link" [href]="attachment.presignedUrl" target="_blank" rel="noopener">
                <nb-icon icon="file-text-outline" pack="eva"></nb-icon>
                <span>{{ fileName(attachment) }}</span>
              </a>
            }
            @for (subFolder of folder.subFolders ?? []; track subFolder.id) {
              <div class="sub-folder">
                <div class="folder-title">
                  <nb-icon icon="folder-outline" pack="eva" [style.color]="subFolder.color"></nb-icon>
                  <span>{{ subFolder.name }}</span>
                </div>
                @for (attachment of subFolder.attachments ?? []; track attachment.s3key) {
                  <a class="document-link" [href]="attachment.presignedUrl" target="_blank" rel="noopener">
                    <nb-icon icon="file-text-outline" pack="eva"></nb-icon>
                    <span>{{ fileName(attachment) }}</span>
                  </a>
                } @empty {
                  <span class="empty-hint">leer</span>
                }
              </div>
            }
            @if (!folder.attachments?.length && !folder.subFolders?.length) {
              <span class="empty-hint">leer</span>
            }
          </div>
        } @empty {
          <span class="info-value">Keine Dokumente vorhanden</span>
        }
      }
    </div>

  </div>
} @else {
  <div class="loading-state">
    <nb-spinner status="primary"></nb-spinner>
  </div>
}
